import React, { useState, useEffect, useCallback } from 'react';
import './Funds.scss';
import Tooltip from '../../commons/tooltip/Tooltip';
import StackedBarChart from '../../commons/stacked-bar-chart/StackedBarChart';

const SectionFunds = ({ dateRange, bars, information }) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  const [currentDateRange, setCurrentDateRange] = useState('');

  useEffect(() => {
    if (dateRange) {
      setCurrentDateRange(dateRange.text);
    }
  }, [dateRange]);

  const toggleTooltip = useCallback((event) => {
    event.preventDefault();
    setOpenTooltip((prev) => !prev);
  }, []);

  const stackedBarChartProps = {
    bars: bars
  };

  const toolTipData = {
    title: information.btnInformation.reference.popPup.title,
    description: information.btnInformation.reference.popPup.description
  };

  const tagBtnInformation = () => {
    let title = information.btnInformation.title;
    title = title.split("#");
    return (
      <a
        href={"#!"}
        className={`btn btn-legal-information`}
        onClick={toggleTooltip}
      >
        {title[0]}{" "}
        <strong>{information.btnInformation.reference.name}</strong>
      </a>
    );
  };

  const tagSplitStrong = () => {
    let description = toolTipData.description;
    let subString = description.split("#");
    return (
      <div>
        <strong>{subString[1]}</strong> {subString[2]}<strong>{subString[3]}</strong>
      </div>
    );
  };

  return (
    <div id={'fondos-netos-captados'} className={`container hbi-section-funds grafico3`}>
      <div className={`text-center`}>
        <h2 className={`text-title`}>{information.title}</h2>
        <p className={`hbi-text-funds`}>
          {information.subTitle} <strong>/ {currentDateRange}</strong>
        </p>
      </div>
      <div className={`text-center content-bg`}>
        <StackedBarChart {...stackedBarChartProps} />
      </div>
      <div className={`hbi-content-position`}>
        <ul className={`hbi-position`}>
          <li className={`hbi-item-position`}>HABITAT</li>
          <li className={`hbi-item-position`}>INTEGRA</li>
          <li className={`hbi-item-position`}>PRIMA</li>
          <li className={`hbi-item-position`}>PROFUTURO</li>
        </ul>
        <p className={`hbi-content-position--months`}>
          {information.lastMonths}
        </p>
      </div>
      <div className={`hbi-content-legal hbi-reference-topltip d-none`}>
        {tagBtnInformation()}
        {openTooltip && <Tooltip {...toolTipData} />}
      </div>
      <div className={`container tooltip-responsive-hiden`}>
        <div className={`container tooltip-reference`}>
          <div>{tagSplitStrong()}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionFunds;